/** ==================== Profile ==================== */
export interface CareerMentorProfileData {
  phone?: string
  verifiedPhone?: boolean
  personalEmail?: string
  birthDate?: string
}

/** ==================== Requests ==================== */
export interface CareerMentorUpdatePhoneParams {
  phone: string
  personalEmail?: string
  birthDate?: string
}

export interface CareerMentorActiveMessageParams {
  templateName: string
  language: string
  searchTerm?: string
}

/** ==================== Message Templates ==================== */
export const CAREER_MENTOR_MESSAGE_TEMPLATE = {
  CONTACT_REQUEST: 'respond_contact_request_template',
  CONTACT_REQUEST_FROM_SEARCH: 'respond_contact_request_from_search_template'
} as const

export type CareerMentorTemplateName =
  (typeof CAREER_MENTOR_MESSAGE_TEMPLATE)[keyof typeof CAREER_MENTOR_MESSAGE_TEMPLATE]
